import { render, staticRenderFns } from "./HeadingVideo.vue?vue&type=template&id=8206dee4&scoped=true&"
import script from "./HeadingVideo.vue?vue&type=script&lang=js&"
export * from "./HeadingVideo.vue?vue&type=script&lang=js&"
import style0 from "./HeadingVideo.vue?vue&type=style&index=0&id=8206dee4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8206dee4",
  null
  
)

export default component.exports